import React from 'react'
import { Grid } from '@material-ui/core'
import MainText from './MainText'
import './Main.css'

const Main = () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      className="main"
    >
      <MainText />
    </Grid>
  )
}

export default Main
